import React from "react";
import Button from "react-bootstrap/es/Button";
import {Col, Row} from "react-bootstrap";

class MapGrid {
  title = 'Lista de Mapas';
  columns = [
    {
      Header: "Nome",
      accessor: "friendlyName"
    },
    {
      Header: "Descrição",
      accessor: "description"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col lg={6}>
              <a href={"#/maps/" + row.original.id + "/polygons"}>
                <Button bsStyle="primary" block>Poligono</Button>
              </a>
            </Col>
            <Col lg={6}>
              <a href={"#/maps/" + row.original.id + "/edit"}>
                <Button bsStyle="success" block>Editar</Button>
              </a>
            </Col>
          </Row>
      ),
    }
  ];
  endpoint = "polygon/v1/maps";
}

export default MapGrid;



// WEBPACK FOOTER //
// ./src/map/MapGrid.js